var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItinerary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.42 53.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M44.59 52.11a6.1 6.1 0 0 1-3.23 0l-16.92-3.88a6.5 6.5 0 0 0-3.33 0L4.54 52.07a2.41 2.41 0 0 1-3-2.32v-41a2.42 2.42 0 0 1 1.75-2.37l17.65-4.12a6.4 6.4 0 0 1 3.28 0L41.38 6.1a6.1 6.1 0 0 0 3.18 0l16.32-4.52a2.42 2.42 0 0 1 3 2.33V45a2.43 2.43 0 0 1-1.79 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M15.9 15.54c0 2.25-4.36 11.16-4.36 11.16s-4.36-8.91-4.36-11.16a4.23 4.23 0 0 1 4.36-4.09 4.23 4.23 0 0 1 4.36 4.09"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.54,
    cy: 15.65,
    r: 1.32,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M58 28c0 2.26-4.36 11.17-4.36 11.17S49.25 30.21 49.25 28A4.37 4.37 0 0 1 58 28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.61,
    cy: 28.07,
    r: 1.32,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M42.79 6.56v45.87M22.5 2.25v45.87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItinerary);
export default __webpack_public_path__ + "static/media/itinerary.f51930226cbfb7f33be71e6d512e48f7.svg";
export { ForwardRef as ReactComponent };